<template>
    <div class="page rewardHistory">
        <TopNavBar/>
        <div class="container">
            <div class="historyList" v-if="rewHistList">
                <div class="el" v-for="elment in rewHistList">
                    <div class="leftCol">
                        <div class="date h5">
                            {{ dateTransform(elment.added) }}
                        </div>
                        <div class="title" v-html="">
                            {{ elment.business_name }}
                        </div>
                    </div>
                    <div class="minusPoints caption">
                        {{ elment.points }}pts
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from "moment";
    import TopNavBar from "../../components/shared/TopNavBar";

    export default {
        components: {TopNavBar},
        data() {
            return {
                rewHistList: null,
                orderTypes: ['accept', 'event', 'import', 'logpurchase', 'order', 'profile', 'redeem', 'referral', 'refund', 'reward', 'reward_voided', 'sign_in', 'survey', 'transfer' ]
            }
        },
        created() {
            this.$store.commit("shared/setTopBar", {title: "Transaction History", showBackButton: true}, {root: true});
            this.$store.dispatch("cart/getUserLoyaltyHistory", {
                callback: (res) => {
                    //console.log(res.data)
                    this.rewHistList = res.data;

                    this.rewHistList = this.rewHistList.filter(o =>{
                        if (this.orderTypes.includes(o.object_type)){
                            o.points = (+o.points >=0) ? `+${o.points}` : `${o.points}`
                            return  true;
                        }else {
                            return false
                        }
                    })
                }
            })
        },
        methods: {
            dateTransform(date) {
                return moment(date).format("MMM DD [AT] h:mm a")
            },
        }
    }
</script>

<!--accept - Points earned when gift campaign was "accepted" (redeemed).
event - Points added to member because of app event (sign up, for example).
import - Points added when member was imported and points history was moved over; so this is the points init record.
logpurchase - Points earned for purchase being logged for a member; usually through CCP or POS.
order - Points earned for online order placed.
profile - Points earned for profile completed action.
redeem - Points earned for offer redemption.
referral - Points earned for referred member.
refund - Points deducted in case purchase was refunded.
reward - Points deducted when reward was used (costs points to redeem).
reward_voided - Points added back when reward was voided.
sign_in - Not used anymore, can be skipped. Was used to give points for the first sign in to the app, as I remember.
survey - Points earned for completing a survey.
transfer - Points added as a result of transfer from one member to another.-->
